// extracted by mini-css-extract-plugin
export default {"cardInfo":"cardInfo_cardInfo__i295r"};